var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionMarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5213",
    "data-name": "Group 5213",
    transform: "translate(20843 13034)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13128",
    "data-name": "Path 13128",
    d: "M167.539,78.4a19.139,19.139,0,1,0,19.139,19.139A19.156,19.156,0,0,0,167.539,78.4Zm0,2.127a17.013,17.013,0,1,1-17.013,17.013A17,17,0,0,1,167.539,80.525Zm-.017,6.912a7.084,7.084,0,0,0-6.263,4.336,1.063,1.063,0,1,0,1.927.881,5.047,5.047,0,0,1,4.353-3.09h.017a5.184,5.184,0,0,1,3.522,1.2,3.931,3.931,0,0,1,1.246,3.057,2.877,2.877,0,0,1-.681,1.828,14.216,14.216,0,0,1-1.861,1.861c-1.452,1.293-3.255,2.844-3.306,5.316a1.064,1.064,0,1,0,2.126.05c.03-1.432,1.14-2.479,2.592-3.772a15.28,15.28,0,0,0,2.143-2.177,5.145,5.145,0,0,0,1.113-3.107,6.18,6.18,0,0,0-1.944-4.635,7.351,7.351,0,0,0-4.967-1.744h-.017Zm-.515,18.076a.53.53,0,0,0-.531.532v1.063a.53.53,0,0,0,.531.531h1.064a.53.53,0,0,0,.531-.531v-1.063a.53.53,0,0,0-.531-.532Z",
    transform: "translate(-20986.537 -13107.537)",
    fill: "#212a42"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1627",
    "data-name": "Rectangle 1627",
    width: 48,
    height: 48,
    transform: "translate(-20843 -13034)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMarkIcon);
export default __webpack_public_path__ + "static/media/QuestionMarkIcon.daf1215e8d5b7a9e293f10a42901e8d4.svg";
export { ForwardRef as ReactComponent };